// Big clubs + popular nations float to the top of discovery pickers. We have no
// popularity ranking in the free data, so this is a curated nudge by name match.
export const POPULAR_TEAMS = [
  'real madrid', 'barcelona', 'liverpool', 'manchester city', 'manchester united',
  'arsenal', 'chelsea', 'tottenham', 'bayern', 'paris', 'juventus', 'milan',
  'inter', 'atlético', 'atletico', 'dortmund', 'napoli', 'roma', 'ajax',
  'benfica', 'porto', 'egypt', 'argentina', 'brazil', 'portugal', 'france',
  'spain', 'england', 'germany', 'italy', 'morocco', 'saudi',
];

export function popularityRank(name: string): number {
  const lower = name.toLowerCase();
  const index = POPULAR_TEAMS.findIndex((keyword) => lower.includes(keyword));
  return index < 0 ? 999 : index;
}

/** Sort a team-like list with the big names first, then alphabetically. */
export function sortByPopularity<T extends { name: string }>(teams: T[]): T[] {
  return [...teams].sort(
    (a, b) => popularityRank(a.name) - popularityRank(b.name) || a.name.localeCompare(b.name),
  );
}

const KNOCKOUT_RE = /final|semi|quarter|round of (?:16|32)|last[ _](?:16|32)|knockout|playoff/i;

/** Whether a round string is a knockout stage (handles API-Football human labels
 *  like "Round of 16" / "Quarter-finals" / "Final", not just code constants). */
export function isKnockout(round: string | null | undefined): boolean {
  return !!round && KNOCKOUT_RE.test(round);
}

/**
 * A "hot" / highly-anticipated match worth a flame badge: either both sides are
 * big names, or it's a knockout tie involving at least one big name. Pure + cheap
 * (substring rank), safe to call per row.
 */
export function isHotMatch(fixture: {
  home_team: { name: string } | null;
  away_team: { name: string } | null;
  round: string | null;
}): boolean {
  const homeName = fixture.home_team?.name;
  const awayName = fixture.away_team?.name;
  if (!homeName || !awayName) return false;
  const homeBig = popularityRank(homeName) < 999;
  const awayBig = popularityRank(awayName) < 999;
  if (homeBig && awayBig) return true;
  return isKnockout(fixture.round) && (homeBig || awayBig);
}
